import { combineReducers } from 'redux';
import appReducer from './app-reducer';
import routerReducer from './router-reducer';

const rootReducer = combineReducers({
  app: appReducer,
  router: routerReducer
});

export default rootReducer;